import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { dataService } from '../services/dataService';
import { UserAccountManager, DashboardHeader } from '../components';
import '../styles/dashboard-header.css';

const CoachAccount: React.FC = () => {
  const { user } = useApp();
  const [schools, setSchools] = useState<Array<{id: string; name: string}>>([]);

  useEffect(() => {
    const loadSchools = async () => {
      try {
        // Load from both SMS schools and App schools
        const [smsSchoolsData, appSchoolsData] = await Promise.all([
          dataService.getSchools(),
          dataService.getAppSchools()
        ]);
        
        const smsSchools = smsSchoolsData.map((school: any) => ({
          id: school.id,
          name: school.name
        }));
        
        const appSchools = appSchoolsData.map((school: any) => ({
          id: school.id,
          name: school.name
        }));
        
        // Combine and sort alphabetically
        const allSchools = [...smsSchools, ...appSchools].sort((a, b) => 
          a.name.localeCompare(b.name)
        );
        
        setSchools(allSchools);
      } catch (error) {
        console.error('Failed to load schools:', error);
      }
    };

    loadSchools();
  }, []);

  const handleUserUpdate = (updatedUser: any) => {
    // Handle user update - could update context, show notification, etc.
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <DashboardHeader />
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0A0E17 0%, #111827 50%, #0A0E17 100%)',
        padding: '2rem 1rem',
        paddingTop: '100px'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <UserAccountManager 
          currentUser={user}
          onUserUpdate={handleUserUpdate}
          schools={schools}
          disableSchoolChange={true}
        />
        </div>
      </div>
    </>
  );
};

export default CoachAccount;